var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsole2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 69.82 154.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#828282;}.cls-2{fill:#cbd5e4;}.cls-3{fill:#b8c6cf;}.cls-4{fill:#b9bdc1;}.cls-5{fill:#8ab3ff;}.cls-6{fill:#343f42;}.cls-7{fill:#588df0;}.cls-13,.cls-17,.cls-8{fill:none;}.cls-8{stroke:#588df0;}.cls-13,.cls-15,.cls-17,.cls-8{stroke-miterlimit:10;}.cls-13,.cls-8{stroke-width:0.97px;}.cls-9{fill:#303b3e;}.cls-10{fill:#f44d4d;}.cls-11{fill:#f66562;}.cls-12{fill:#d0d6e2;}.cls-13{stroke:#303b3e;}.cls-14{fill:#9caab2;}.cls-15,.cls-16{fill:#d0d6e1;}.cls-15,.cls-17{stroke:#343f42;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Console_01a",
    "data-name": "Console_01a",
    viewBox: "0 0 69.82 154.44"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "69.82 26.88 69.82 146.88 46.55 154.44 46.55 76.44 60.31 29.82 69.82 26.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.3 3.24 23.27 0 69.82 26.88 60.31 29.82 13.3 3.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 49.56 46.55 76.44 60.31 29.82 13.3 3.24 0 49.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "0 127.56 46.55 154.44 46.55 76.44 0 49.56 0 127.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "51.78 40.35 22.51 23.42 14.63 50.97 43.9 67.9 51.78 40.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M23.7,26.35,49.5,41.28,42.71,65,16.91,50.05l6.79-23.7m-1.19-2.93L14.63,51,43.9,67.9l7.88-27.54L22.51,23.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "32.65 35.68 23.86 30.63 19.13 47.16 27.92 52.21 32.65 35.68"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 47.29,
    y1: 44.13,
    x2: 35.57,
    y2: 37.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 45.7,
    y1: 49.68,
    x2: 33.99,
    y2: 42.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 44.12,
    y1: 55.19,
    x2: 32.42,
    y2: 48.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 42.55,
    y1: 60.7,
    x2: 30.84,
    y2: 53.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M50.08,36.19a2.87,2.87,0,0,0,3.39-2,4,4,0,0,0-1.88-4.4,3.27,3.27,0,0,0-1-.38,2.85,2.85,0,0,0-3.39,2,4,4,0,0,0,1.88,4.4A3.49,3.49,0,0,0,50.08,36.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M45.76,31.59l3.58-1a1.83,1.83,0,0,1,1.59.18,3,3,0,0,1,1.38,3.18,1.6,1.6,0,0,1-.84,1l-4,1.18A1.9,1.9,0,0,1,46,35.91a3,3,0,0,1-1.38-3.18A1.59,1.59,0,0,1,45.76,31.59Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 46.63,
    cy: 33.86,
    rx: 1.91,
    ry: 2.46,
    transform: "translate(-10.58 26.93) rotate(-29.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.29,31.14a2.87,2.87,0,0,0,3.39-2,4,4,0,0,0-1.88-4.4,3.27,3.27,0,0,0-1-.38,2.86,2.86,0,0,0-3.39,2,4,4,0,0,0,1.88,4.4A3.82,3.82,0,0,0,41.29,31.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M37,26.54l3.58-1a1.83,1.83,0,0,1,1.59.18,2.94,2.94,0,0,1,1.38,3.18,1.6,1.6,0,0,1-.84,1l-4,1.18a1.9,1.9,0,0,1-1.42-.23,3,3,0,0,1-1.38-3.18A1.59,1.59,0,0,1,37,26.54Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 37.84,
    cy: 28.81,
    rx: 1.91,
    ry: 2.46,
    transform: "translate(-9.23 22.02) rotate(-29.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M34.26,26.78a2.52,2.52,0,0,0,3-1.81,3.73,3.73,0,0,0-1.75-4.09,2.85,2.85,0,0,0-.9-.35,2.52,2.52,0,0,0-3,1.8,3.77,3.77,0,0,0,1.76,4.1A3.5,3.5,0,0,0,34.26,26.78Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 34.45,
    cy: 23.65,
    rx: 1.91,
    ry: 2.46,
    transform: "translate(-7.15 19.72) rotate(-29.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M28.4,23.41a2.52,2.52,0,0,0,3-1.81,3.74,3.74,0,0,0-1.75-4.09,3.17,3.17,0,0,0-.89-.35,2.54,2.54,0,0,0-3,1.81,3.76,3.76,0,0,0,1.76,4.09A3.17,3.17,0,0,0,28.4,23.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 28.59,
    cy: 20.28,
    rx: 1.91,
    ry: 2.46,
    transform: "translate(-6.25 16.45) rotate(-29.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M22.54,20a2.51,2.51,0,0,0,3-1.81,3.74,3.74,0,0,0-1.75-4.09,3.5,3.5,0,0,0-.89-.35,2.52,2.52,0,0,0-3,1.81,3.73,3.73,0,0,0,1.75,4.09A2.89,2.89,0,0,0,22.54,20Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 22.73,
    cy: 16.92,
    rx: 1.91,
    ry: 2.46,
    transform: "translate(-5.36 13.18) rotate(-29.08)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "21.35 22.74 13.47 50.29 4.68 45.24 12.56 17.69 21.35 22.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M15.09,28.64a2.52,2.52,0,0,0,3-1.81,3.74,3.74,0,0,0-1.75-4.09,3.5,3.5,0,0,0-.89-.35,2.52,2.52,0,0,0-3,1.81,3.73,3.73,0,0,0,1.75,4.09A2.89,2.89,0,0,0,15.09,28.64Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 15.28,
    cy: 25.52,
    rx: 1.91,
    ry: 2.46,
    transform: "translate(-10.48 10.64) rotate(-29.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M12.73,36.91a2.53,2.53,0,0,0,3-1.81A3.75,3.75,0,0,0,14,31a2.71,2.71,0,0,0-.89-.35,2.51,2.51,0,0,0-3,1.81,3.74,3.74,0,0,0,1.75,4.09A3.43,3.43,0,0,0,12.73,36.91Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 12.91,
    cy: 33.78,
    rx: 1.91,
    ry: 2.46,
    transform: "translate(-14.79 10.54) rotate(-29.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M10.36,45.17a2.52,2.52,0,0,0,3-1.81,3.74,3.74,0,0,0-1.75-4.09,3.17,3.17,0,0,0-.89-.35,2.54,2.54,0,0,0-3,1.81,3.76,3.76,0,0,0,1.76,4.09A3.17,3.17,0,0,0,10.36,45.17Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 10.55,
    cy: 42.05,
    rx: 1.91,
    ry: 2.46,
    transform: "translate(-19.11 10.43) rotate(-29.08)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 17.14,
    y1: 31.61,
    x2: 11.28,
    y2: 28.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 14.82,
    y1: 39.72,
    x2: 8.96,
    y2: 36.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 12.42,
    y1: 48.1,
    x2: 6.56,
    y2: 44.73
  }), /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_2",
    "data-name": "New Symbol 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "5.78 69.96 32.38 85.32 32.38 121.32 5.78 105.96 5.78 69.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "29.06 86.4 28.99 101.35 22.41 97.56 22.41 82.56 29.06 86.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "19.08 92.64 19.01 110.59 9.11 104.88 9.11 86.88 19.08 92.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "29.06 104.4 28.99 116.4 22.41 112.6 22.41 100.56 29.06 104.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 9.11,
    y1: 77.88,
    x2: 19.08,
    y2: 83.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 9.11,
    y1: 80.88,
    x2: 19.08,
    y2: 86.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 9.11,
    y1: 83.88,
    x2: 19.08,
    y2: 89.64
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Formulering_Stabilisering",
    "data-name": "Formulering & Stabilisering"
  }, /*#__PURE__*/React.createElement("use", {
    width: 69.82,
    height: 154.44,
    xlinkHref: "#Console_01a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsole2);
export default __webpack_public_path__ + "static/media/console-2.acba094168fa1b48af2c2a4bfeef37b4.svg";
export { ForwardRef as ReactComponent };